module.exports = __webpack_public_path__ + "static/media/legende_confirmed.e57ef7b4.svg";